module.exports = __webpack_public_path__ + "assets/img/star_sentence_un2.2366d15c.png";